module.exports = __webpack_public_path__ + "img/cvv.9142b3b8.svg";